export const ensureArray = (value) => Array.isArray(value) ? value : [value];
//# sourceMappingURL=ensureArray.js.map
// @zapier/design-system@5.32.5 (2004a9d50)
